import type { SxProps, Theme } from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";
import type { ObjectFieldValues } from "../../../../../../api/types/objectTypes";
import { getObjectSelectLabel } from "../../../../../entityFields/helpers";

interface Props {
  options: ObjectFieldValues[];
  value: ObjectFieldValues | null;
  onChange: (newValue: ObjectFieldValues | null) => void;
  label?: string;
  disabled?: boolean;
  error?: boolean;
  sx?: SxProps<Theme>;
}

const ObjectAutocomplete = ({ options, value, onChange, label, disabled, error, sx }: Props) => {
  return (
    <Autocomplete
      fullWidth
      openOnFocus
      disabled={disabled}
      options={options}
      value={value}
      disableClearable={value !== null}
      onChange={(_, newValue) => onChange(newValue)}
      getOptionLabel={getObjectSelectLabel}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => <TextField {...params} label={label} error={error} />}
      slotProps={{
        popper: {
          style: { minWidth: "max-content" },
        },
      }}
      sx={sx}
    />
  );
};

export default ObjectAutocomplete;
